import { PropsWithChildren, ReactNode, useState } from 'react'

import { useOutsideClick } from '../../../../shared/lib/hooks/UseOutsideClick'
import { DropdownPositioner } from '../../dropdown-positioner/component/DropdownPositioner'

interface PopoverProps extends PropsWithChildren {
  trigger: () => ReactNode
}

export const Popover = ({ trigger, children }: PopoverProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const ref = useOutsideClick(() => setIsOpen(false))

  // без z-index: свой слой у содержимого в DropdownPositioner, а триггер со z-index
  // ложился бы поверх чужих выпадашек (фильтры, меню статусов в соседних колонках)
  return (
    <span ref={ref} className={'relative'}>
      <span className={'select-none'} onClick={() => setIsOpen((prev) => !prev)}>
        {trigger()}
      </span>
      {/* не сжимается: сторону выбирает по полной высоте содержимого */}
      <DropdownPositioner
        gap={8}
        minHeight={Infinity}
        open={isOpen}
        position='auto'
        width='content'
      >
        <div
          className={
            'rounded-[12px] bg-white px-[24px] py-[16px] shadow-depth-200 shadow-focus-500/[0.24]'
          }
        >
          {children}
        </div>
      </DropdownPositioner>
    </span>
  )
}
